<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27.506"
    height="16.828"
    viewBox="0 0 27.506 16.828"
  >
    <g transform="translate(-386.247 -392.086)">
      <g>
        <path
          d="M410.041,408.914H386.247l.038-.622a58.083,58.083,0,0,1,1.511-10.108l.684.035.261-.168a5.331,5.331,0,0,0,1.277.987c.794.516,2.388-.35,3.224-.927l-1.184-3.157,1.108.443a58.018,58.018,0,0,1,6.286,2.967,23.741,23.741,0,0,0,5.182,1.822,18.125,18.125,0,0,1,4.447,1.576c2.315,1.464,1.12,6.509,1.067,6.722Zm-22.685-1.166h21.883c.278-1.435.539-4.208-.674-4.971a17.884,17.884,0,0,0-4.177-1.458,24.333,24.333,0,0,1-5.4-1.911q-2.454-1.339-5.06-2.448l.6,1.586-.344.271c-.306.233-3.025,2.318-4.684,1.234-.389-.252-.689-.466-.919-.646a56.7,56.7,0,0,0-1.22,8.342Z"
          fill="#777"
        />
        <rect
          width="23.254"
          height="1.144"
          transform="translate(386.908 404.904)"
          fill="#777"
        />
        <rect
          width="3.155"
          height="1.142"
          transform="translate(396.258 400.688) rotate(-60.477)"
          fill="#777"
        />
        <rect
          width="2.841"
          height="1.144"
          transform="matrix(0.512, -0.859, 0.859, 0.512, 398.407, 401.542)"
          fill="#777"
        />
      </g>
      <rect
        width="1"
        height="6.584"
        transform="translate(410.004 393.079)"
        fill="#777"
      />
      <path
        d="M413.081,395.818l-2.6-2.367-2.487,2.36-.687-.726,3.161-3,3.289,2.991Z"
        fill="#777"
      />
    </g>
  </svg>
</template>
